export default __webpack_public_path__ + "static/media/team_a_wins.dca0b7d1.mp3";